// Copyright 2023, Avation Medical. All rights reserved.
// 
// This code is proprietary and confidential information of Avation Medical. Any use, reproduction, modification
// or distribution of the code without the express prior written consent of Avation Medical is strictly prohibited.

import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'tos-agreement',
  templateUrl: './tos-agreement.component.html',
  styleUrls: ['./tos-agreement.component.scss']
})
export class TOSAgreementComponent implements OnInit {

  htmlLoc$: Observable<SafeResourceUrl>;
  canAccept: boolean = false;
  checked: boolean = false;

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly sanitizer: DomSanitizer) 
  { }

  ngOnInit(): void {
    this.htmlLoc$ =this.authService.getEULA().pipe(
      map(response => this.sanitizer.bypassSecurityTrustHtml(response.html))
    );
  }
  
  async onAccept(): Promise<void> {
    await this.authService.acceptedEULA().toPromise().then(() => {
     this.router.navigate(['/']);
    });
  }

  onDecline(): void {
    this.authService.logout();
  }

//   onScroll(event: any) {
//     // visible height + pixel scrolled >= total height 
//     if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {
//       this.canAccept = true;
//     }
// }
}
